export const codeInputStyles = {
  fontFamily: 'monospace',
  MozAppearance: 'textfield',
  borderRadius: '6px',
  border: '1px solid',
  boxShadow: '0px 0px 10px 0px rgba(0,0,0,.10)',
  margin: '4px',
  paddingLeft: '8px',
  paddingRight: 0,
  width: '36px',
  height: '42px',
  fontSize: '20px',
  boxSizing: 'border-box',
} as any
